import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import {
  LeavePostsGroupDocument,
  MyCommunitiesDocument,
  OtherCommunitiesDocument,
  PostsGroupHeaderDocument,
} from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  onClose: () => void
  groupId: number
}

function LeaveGroup({ onClose, groupId }: Props) {
  const { data, loading } = useQuery(PostsGroupHeaderDocument, {
    variables: {
      id: groupId,
    },
  })

  const group = data?.posts.group

  const [leaveGroup] = useMutation(LeavePostsGroupDocument, {
    extractorFn: (mutationData) => mutationData.postsMutations.leavePostsGroup,
  })

  const submit = async (closePortal: ClosePortalFn) => {
    if (!group) return

    const result = await leaveGroup({
      variables: {
        id: groupId,
      },
      refetchQueries: [
        {
          query: PostsGroupHeaderDocument,
          variables: { id: groupId },
        },
        {
          query: MyCommunitiesDocument,
        },
        {
          query: OtherCommunitiesDocument,
        },
      ],
    })

    const handled = handleResult(result, (_errors) => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('posts.communities.error_message'),
      })
    })

    if (handled.success) {
      closePortal()
    }
  }

  if (loading) return <Loading />

  if (!group) return null

  return (
    <Modal
      description={i18n.t('dashboard.groups.leave.description')}
      illustration="delete-cross"
      onClose={onClose}
      onSubmit={submit}
      title={i18n.t('dashboard.groups.leave.title')}
      footer={
        <Button disabled={!group} submit>
          {i18n.t('dashboard.groups.leave.title')}
        </Button>
      }
    />
  )
}

export default LeaveGroup
